import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Carousel,
} from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../styles/reservas.css";

import reservaMesa from "../assets/dist/img/reservado.jpg";
import reservaEvento from "../assets/dist/img/reservado.jpg";
import reservaFiesta from "../assets/dist/img/reservado.jpg";
import reservaReunion from "../assets/dist/img/reservado.jpg";
const reservaTipos = [
  {
    id: 1,
    title: "Reserva de Mesa",
    description: "Reserva tu mesa para disfrutar del café",
    image: reservaMesa,
    beneficios: [
      "Wi-Fi disponible",
      "Atención personalizada",
      "Ambiente tranquilo y cómodo",
    ],
  },
  {
    id: 2,
    title: "Eventos",
    description: "Asiste o reserva eventos especiales (máx. 15 personas)",
    image: reservaEvento,
    beneficios: [
      "Espacio exclusivo para tu evento",
      "Equipo de sonido básico incluido",
      "Apoyo del staff durante la actividad",
    ],
  },
  {
    id: 3,
    title: "Celebraciones",
    description: "Cumpleaños, aniversarios y más (máx. 15 personas)",
    image: reservaFiesta,
    beneficios: [
      "Decoración sencilla incluida",
      "Opciones de consumo personalizadas",
      "Flexibilidad de horario",
    ],
  },
  {
    id: 4,
    title: "Otros",
    description: "Reuniones, coworking, encuentros privados",
    image: reservaReunion,
    beneficios: [
      "Wi-Fi estable para trabajo o reuniones",
      "Espacio cómodo para grupos pequeños",
      "Ambiente ideal para concentración",
    ],
  },
];

const ReservaForm = () => {
  const [showForm, setShowForm] = useState(false);
  const [selectedType, setSelectedType] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    date: "",
    time: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.date || !formData.time) {
      toast.error("Por favor, completa todos los campos obligatorios.");
      return;
    }

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          ...formData,
          reservation_type: selectedType,
        },
        process.env.REACT_APP_EMAILJS_USER_ID,
      )
      .then(() => {
        toast.success("¡Reserva enviada con éxito!");
        setFormData({
          name: "",
          email: "",
          date: "",
          time: "",
          phone: "",
          message: "",
        });
        setShowForm(false);
      })
      .catch(() => toast.error("Error al enviar la reserva."));
  };

  return (
    <Container className="mt-5 mb-5 reservas-container">
      {/* ===== CARRUSEL ===== */}
      <Carousel className="reservas-carousel">
        {reservaTipos.map((item) => (
          <Carousel.Item key={item.id} className="reservas-item">
            <img
              className="d-block w-100 reservas-img"
              src={item.image}
              alt={item.title}
            />

            <Carousel.Caption className="reservas-caption">
              <div className="reservas-content">
                <div className="reservas-title">{item.title}</div>

                <div className="reservas-description">{item.description}</div>

                <div className="reservas-beneficios">
                  {item.beneficios.map((beneficios, index) => (
                    <div key={index} className="reservas-beneficio">
                      {beneficios}
                    </div>
                  ))}
                </div>
                <div className="reservas-action">
                  <Button
                    className="evento-btn"
                    variant="light"
                    onClick={() => {
                      if (showForm && selectedType === item.title) {
                        setShowForm(false);
                        setSelectedType("");
                      } else {
                        setShowForm(true);
                        setSelectedType(item.title);
                      }
                    }}
                  >
                    {showForm && selectedType === item.title
                      ? "Ocultar"
                      : "Reservar"}
                  </Button>
                </div>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>

      {/* ===== FORMULARIO (OCULTO / MOSTRADO) ===== */}
      {showForm && (
        <Row className="justify-content-center mt-5">
          <Col lg={6} md={8}>
            <Card className="p-4 shadow-lg">
              <Card.Body>
                <h2 className="text-center mb-4">Reserva: {selectedType}</h2>

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Fecha</Form.Label>
                    <Form.Control
                      type="date"
                      name="date"
                      value={formData.date}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Hora</Form.Label>
                    <Form.Control
                      type="time"
                      name="time"
                      value={formData.time}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Celular</Form.Label>
                    <Form.Control
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Mensaje</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Button type="submit" className="w-100">
                    Confirmar reserva
                  </Button>

                  <Button
                    variant="outline-secondary"
                    className="w-100 mt-3"
                    onClick={() => setShowForm(false)}
                  >
                    Ocultar formulario
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      <ToastContainer />
    </Container>
  );
};

export default ReservaForm;
